import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: '[controlErrorContainer]',
})
export class ControlErrorContainerDirective {
  constructor(public vcr: ViewContainerRef) {}
}
